var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card-title',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.header)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }